<template>
  <div class="files-container">
    <div class="file-list" v-if="downloadFiles.length > 0">
      <div class="file-item" v-for="file in downloadFiles" :key="file.fileId">
        <a-tag class="tag-tiny v-mr-xs" color="#f50" v-if="file.isChoice">精</a-tag>
        <img class="file-img" src="~@/assets/images/file_word.svg" v-if="['doc', 'docx'].includes(file.fileFormat)" />
        <img class="file-img" src="~@/assets/images/file_excel.svg" v-else-if="['xls', 'xlsx'].includes(file.fileFormat)" />
        <img class="file-img" src="~@/assets/images/file_ppt.svg" v-else-if="['ppt', 'pptx'].includes(file.fileFormat)" />
        <img class="file-img" src="~@/assets/images/file_compress.svg" v-else-if="['rar', 'zip', 'tar', '7z'].includes(file.fileFormat)" />
        <img class="file-img" src="~@/assets/images/file_txt.svg" v-else-if="file.fileFormat === 'txt'" />
        <img class="file-img" src="~@/assets/images/file_pdf.svg" v-else-if="file.fileFormat === 'pdf'" />
        <img class="file-img" src="~@/assets/images/file_video.svg" v-else-if="file.fileFormat === 'video'" />
        <img class="file-img" src="~@/assets/images/file_default.svg" v-else />
        <span class="text-indigo hover-line overflow-hidden ellipsis" :title="file.fileOriginName" @click="onFileClick({ fileId: file.fileId, belongId, fileSign, fileName: file.fileOriginName })">{{ $utils.truncateFileName(file.fileOriginName, 40) }}</span>
      </div>
    </div>
    <div class="file-list" v-if="imgFiles.length > 0">
      <div class="file-imgs" v-viewer="{ movable: true, transition: false, toolbar: true, url: 'data-original' }">
        <div class="file-item-img" :class="{ 'file-chosen': file.isChoice }" :style="{ width: `${typeof imgSize == 'numbner' ? imgSize : imgSize[0]}px`, height: `${typeof imgSize == 'numbner' ? imgSize : imgSize[1]}px`}" v-for="file in imgFiles" :key="file.fileId">
          <div class="ribbon ribbon-small" v-if="file.isChoice"><div class="ribbon-text">精选</div></div>
          <img v-lazy="`${baseURL}/file/img?id=${file.fileId}&belongId=${belongId}&fileSign=${fileSign}&thumb=1`" :data-original="`${baseURL}/file/img?id=${file.fileId}&belongId=${belongId}&fileSign=${fileSign}`" title="点击查看大图" v-if="file.classify == 'image'"/>
          <!-- <player :url="`${baseURL}/file/view?id=${file.fileId}&belongId=${belongId}&fileSign=${fileSign}`" :config="{ videoInit: true }" v-else-if="file.classify == 'video'"/> -->
          <template v-else-if="file.classify == 'video'">
            <player :ref="`player-${file.fileId}`" :url="`${baseURL}/file/view?id=${file.fileId}&belongId=${belongId || file.fileBelongId}&fileSign=${fileSign}`" :config="{ videoInit: true }" />
            <div class="player-controls">
              <div class="player-control" title="查看视频" @click="playVideo(file)"><i class="fa fa-play" /></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@/components/player'
export default {
  name: 'FileContainer',
  components: {
    Player,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    belongId: {
      type: Number,
    },
    fileSign: {
      type: String,
    },
    imgSize: {
      type: [Number, Array],
      default: 48,
    },
  },
  data() {
    return {
      imgFiles: [],
      downloadFiles: [],
    }
  },
  watch: {
    files() {
      this.splitFiles()
    },
  },
  methods: {
    splitFiles() {
      let imgFiles = []
      let downloadFiles = []
      this.files.forEach(file => {
        let { fileFormat } = file
        let classify = 'default'
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileFormat)) {
          classify = 'image'
        } else if (['rar', 'zip', '7z'].includes(fileFormat)) {
          classify = 'compress'
        } else if (['xls', 'xlsx'].includes(fileFormat)) {
          classify = 'excel'
        } else if (['doc', 'docx', 'wps'].includes(fileFormat)) {
          classify = 'word'
        } else if (['mp4', 'wmv', 'rmvb', 'avi', 'mov', 'mkv'].includes(fileFormat)) {
          classify = 'video'
        } else if (['ppt', 'pptx'].includes(fileFormat)) {
          classify = 'ppt'
        }
        file.classify = classify
        if (classify === 'image' || classify === 'video') {
          imgFiles.push(file)
        } else {
          downloadFiles.push(file)
        }
      })
      this.imgFiles = imgFiles
      this.downloadFiles = downloadFiles
    },
    playVideo(file) {
      let { fileId, fileBelongId } = file
      let { baseURL, fileSign, belongId } = this
      let url = `${baseURL}/file/view?id=${fileId}&belongId=${belongId || fileBelongId}&fileSign=${fileSign}`
      this.$root.$emit('previewVideo', url)
    },
    onFileClick(file) {
      let { baseURL } = this
      let { fileId, belongId, fileSign, fileName} = file
      console.log('fileClick', fileId, belongId, fileSign, fileName)
      if (fileName.endsWith('.pdf')) {
        let url = `${baseURL}/file/view?id=${fileId}&belongId=${belongId}&fileSign=${fileSign}`
        // window.open('./pdf/web/viewer.html?file='+encodeURIComponent(url));
        this.$root.$emit('previewPdf', encodeURIComponent(url))
      } else {
        this.downloadFile(file)
      }
    }
  },
  mounted() {
    this.splitFiles()
  },
}
</script>
